import Props from '../../../../shared/types/props/button';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useContext, useState, useCallback, useEffect } from 'react';
import ListContext from '../../../../shared/components/utils/context/listContext';
import Button from '../../atoms/buttons/modalButton';
import { useAppSelector } from '../../../../shared/store/hooks';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';

function DefaultButton({
  action,
  releaseAction,
  index,
  text = 'MODAL.ANONYMOUS.BUTTONS.CANCEL',
}: Props) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex, listFocused } = useContext(ListContext);
  const [focused, setFocused] = useState(false);

  // Event handlers

  const onPointerEnter = useCallback(() => {
    setFocused(true);
  }, []);

  const onPointerLeave = useCallback(() => {
    setFocused(listIndex === index);
  }, [listIndex]);

  // Effect hooks

  useEffect(() => {
    setFocused(listFocused && listIndex === index);
  }, [listIndex, listFocused]);
  return (
    <Button
      focused={!enabled && focused}
      onClick={action || releaseAction}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
      id={'modalButton'}
    >
      {TranslationManager.get(text)}
    </Button>
  );
}

export default DefaultButton;
